import { useContext } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import { AppContext } from "../../root/Root";

// ⚠️ on importe le composant avec un alias pour éviter le conflit de nom
import { DataIngestion as DataIngestionComponent } from "../../../components/audience/dataIngestion/DataIngestion";

// ✅ Export NOMMÉ pour correspondre à: import {DataIngestion} from ".../pages/..."
export function DataIngestion() {
  useContext(AppContext);
  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid md={12}>
          <DataIngestionComponent />
        </Grid>
      </Grid>
    </DefaultLayout>
  );
}
